export default "__VITE_ASSET__CDpwk_F0__"